import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/lib/auth";
import { ReferralDialog } from "@/components/ReferralDialog";
import { AdminDialog } from "@/components/AdminDialog";
import { LogIn, LogOut, Gift, Crown, User as UserIcon, ShieldCheck, Eye, Smartphone } from "lucide-react";
import { InstallDialog } from "@/components/InstallDialog";

export function AccountMenu() {
  const { user, isPro, isAdmin, login, logout, previewFree, setPreviewFree } = useAuth();

  if (!user) {
    return (
      <button data-testid="sign-in-button" onClick={login}
        className="flex items-center gap-1.5 h-9 px-3 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-xs font-semibold transition-colors">
        <LogIn size={14} /> <span className="hidden sm:inline">Sign in</span>
      </button>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="account-menu-button"
          className="w-9 h-9 rounded-full overflow-hidden border border-white/15 bg-white/5 grid place-items-center">
          {user.picture
            ? <img src={user.picture} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" />
            : <UserIcon size={16} className="text-[#9CA3AF]" />}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 bg-[#111827] border-white/10 text-[#F9FAFB] p-0">
        <div className="px-4 py-3 border-b border-white/10">
          <div className="text-sm font-medium truncate">{user.name || "Trader"}</div>
          <div className="text-[11px] text-[#9CA3AF] truncate">{user.email}</div>
          <div className="mt-1.5">
            {isPro ? (
              <span className="inline-flex items-center gap-1 text-[10px] font-mono-num px-2 py-0.5 rounded-full bg-[#F59E0B]/15 text-[#F59E0B] border border-[#F59E0B]/40">
                <Crown size={11} /> PRO
              </span>
            ) : (
              <span className="text-[10px] font-mono-num text-[#6B7280]">Free plan</span>
            )}
          </div>
        </div>
        <div className="p-1">
          {isAdmin && (
            <>
              <AdminDialog trigger={
                <button data-testid="admin-menu" className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-white/5 text-left">
                  <ShieldCheck size={15} className="text-[#10B981]" /> Admin panel
                </button>
              } />
              <label data-testid="preview-free-toggle" className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm hover:bg-white/5 cursor-pointer">
                <span className="flex items-center gap-2"><Eye size={15} className="text-[#60A5FA]" /> Preview as Free user</span>
                <Switch data-testid="preview-free-switch" checked={previewFree} onCheckedChange={setPreviewFree} />
              </label>
            </>
          )}
          <ReferralDialog trigger={
            <button data-testid="refer-earn-menu" className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-white/5 text-left">
              <Gift size={15} className="text-[#F59E0B]" /> Refer & Earn
            </button>
          } />
          <InstallDialog trigger={
            <button data-testid="install-app-menu" className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-white/5 text-left">
              <Smartphone size={15} className="text-[#60A5FA]" /> Install on phone
            </button>
          } />
          <button data-testid="sign-out-button" onClick={logout}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-white/5 text-left text-[#EF4444]">
            <LogOut size={15} /> Sign out
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
